import React from "react";
import { useDataProvider, useNotify } from "react-admin";

const DownloadSampleButton = ({ downloadType }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const onDownloadSample = async () => {
    try {
      const result = await dataProvider.downloadSampleXls({
        sampleType: downloadType,
      } as any);
      const objectUrl = result?.data?.objectUrl;
      const fileName = result?.data?.fileName;
      if (!objectUrl) {
        throw new Error("Unable to download sample file");
      }

      const anchor = document.createElement("a");
      anchor.href = objectUrl;
      anchor.download = fileName || "sample.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
    } catch (e: any) {
      notify(e?.message || "Unable to download sample file", {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  };

  return (
    <button
      type="button"
      className="blue-btn px-3 bg-transparent shadow-none"
      style={{ color: "#2DC3E8" }}
      onClick={onDownloadSample}
    >
      Download Sample
    </button>
  );
};

export default DownloadSampleButton;
